import {
  PhoneNumber,
  ProviderPhoneNumber,
  DriverPhoneNumber,
} from '../data/models/phone-number.model';

export enum ProviderPhoneUse {
  Dispatch = 1,
  Billing = 2,
  Main = 3,
  Owner = 4,
}

export enum DriverPhoneUse {
  Driver = 1,
  Emergency = 2,
  Medical = 3,
}

export enum PhoneType {
  Landline = 1,
  Mobile = 2,
}

class PhoneUtils {
  public getProviderPhone(
    phoneNumbers: ProviderPhoneNumber[] | undefined,
    use: ProviderPhoneUse,
  ): ProviderPhoneNumber | undefined {
    return (phoneNumbers || []).find(
      (num) => num.transportationProviderPhoneUseID === use,
    );
  }

  public getDriverPrimaryPhone(
    phoneNumbers: DriverPhoneNumber[] | undefined,
  ): any {
    return (phoneNumbers || []).find(
      (num) =>
        num.driverPhoneUseID === DriverPhoneUse.Driver &&
        num.isPrimaryPhoneNumber,
    );
  }

  public getDriverSecondaryPhone(
    phoneNumbers: DriverPhoneNumber[] | undefined,
  ): DriverPhoneNumber | undefined {
    return (phoneNumbers || []).find((num) => {
      return (
        num.driverPhoneUseID === DriverPhoneUse.Driver &&
        !num.isPrimaryPhoneNumber
      );
    });
  }

  public getDriverEmergencyPhone(
    phoneNumbers: DriverPhoneNumber[] | undefined,
  ): DriverPhoneNumber | undefined {
    return (phoneNumbers || []).find(
      (num) => num.driverPhoneUseID === DriverPhoneUse.Emergency,
    );
  }

  public formatPhone(phoneNumber?: PhoneNumber, withExtension = false): string {
    if (!phoneNumber) {
      return '';
    }
    // TODO: this needs to be fixed to handle multi digit country codes
    const num = phoneNumber.phoneNumber.replace(
      /(\d{1})(\d{3})(\d{3})(\d{4})/,
      '($1)$2-$3-$4',
    );
    const ext =
      withExtension && phoneNumber.phoneExtension
        ? ` ext. ${phoneNumber.phoneExtension}`
        : '';
    return `${num}${ext}`;
  }

  public formatTenDigitPhone(phone: string): string {
    const digits = phone.replace(/\D/g, '').slice(-10);
    return digits.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  }
}

const phoneUtils = new PhoneUtils();

export default phoneUtils;
